import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { naptaProjectsApi } from './api/naptaProjectsApi';
import { NaptaProjectPicker } from './components/NaptaProjectPicker';

const naptaProjectPickerFormField = FormFieldBlueprint.make({
  name: 'napta-project-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'NaptaProjectPicker',
        component: NaptaProjectPicker,
      }),
  },
});

export const naptaPickerScaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [naptaProjectsApi, naptaProjectPickerFormField],
});
